module.exports = "<div v-show=!showManager class=home> <div class=top-action> <top-search :searchtype=searchtype :keyword.sync=keyword :keyword-change=keywordChange></top-search> <menu v-if=isShowMenu :menu-list=menuList :cateid=cateid :is-show-menu.sync=isShowMenu @change=onMenuChange></menu> <navigationbar :menu-list=menuList :cateid=cateid :is-show-menu.sync=isShowMenu @change=onMenuChange></navigationbar> </div> <div class=info-msg> <slideload :slidemessage=paramArr></slideload> </div> </div> <search-manager v-show=showManager v-el:manager></search-manager>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Home.vue
 ** module id = 312
 ** module chunks = 4
 **/